/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, May 2023
 * @flow
 */

import React from 'react';
import { Card, CardContent, Typography, Avatar } from '@material-ui/core';
import { teal } from '@material-ui/core/colors';
import useStyles from './useStyles';

const defaultBackgroundColor = teal[500];

const CustomCard = ({ label, value, icon, backgroundColor }) => {
  const classes = useStyles();
  const Icon = icon;
  return (
    <Card className={classes.root} elevation={0}>
      <CardContent>
        <Typography variant="h5" component="h2">
          {value}
        </Typography>
        <Typography className={classes.title} color="textSecondary">
          {label.toUpperCase()}
        </Typography>
        <Avatar variant="rounded" className={classes.rounded} style={{ backgroundColor: backgroundColor || defaultBackgroundColor }}>
          <Icon />
        </Avatar>
      </CardContent>
    </Card>
  );
};

export default CustomCard;
